import React, { useContext } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	Slide,
	Grid,
	makeStyles,
	IconButton,
	useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { userServices } from "../services";
import { TextField } from "./";
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddUser(props) {
	const theme = useTheme();
	const classes = useStyles();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const { register, handleSubmit, errors, watch } = useForm();
	const { authState } = useContext(AuthContext);

	const saveUser = async (dataToInsert) => {
		const user = {
			username: dataToInsert.username,
			email: dataToInsert.email,
			roleId: "5ffdbb7cf4de1f43a4caff60",
			password: dataToInsert.password,
		};
		const { status, response } = await userServices.addUser({ user, token: authState.token });
		switch (status) {
			case 201:
				props.close();
				props.reload();
				props.toast(response.message, true);
				break;
			case 200:
				props.toast(response.error.message, true);
				break;
			case 400:
				props.toast(response.error.message, true);
				break;
			default:
				break;
		}
	};
	return (
		<Dialog
			PaperProps={{ style: { borderRadius: 45 } }}
			maxWidth="xs"
			fullScreen={fullScreen}
			open={props.open}
			TransitionComponent={Transition}
		>
			<IconButton aria-label="close" className={classes.closeButton} onClick={props.close}>
				<CloseIcon />
			</IconButton>
			<DialogTitle className={classes.dialogTitle}>Agregar administrador</DialogTitle>
			<DialogContent>
				<form className={classes.form} onSubmit={handleSubmit(saveUser)}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="email"
								placeholder="Email *"
								label="Correo electrónico"
								name="email"
								size="small"
								autoComplete="email"
								inputRef={register({
									required: "Correo requerido",
									pattern: {
										value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
										message: "Formato de correo inválido",
									},
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.email ? true : false}
								helperText={errors.email ? errors.email.message : ""}
							/>
						</Grid>

						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="username"
								label="Usuario"
								placeholder="Usuario *"
								name="username"
								size="small"
								autoComplete="username"
								inputRef={register({
									required: "Usuario requerido",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.username ? true : false}
								helperText={errors.username ? errors.username.message : ""}
							/>
						</Grid>

						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="password"
								placeholder="Contraseña *"
								name="password"
								size="small"
								autoComplete="password"
								type="password"
								inputRef={register({
									required: "Contraseña  requerida",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.password ? true : false}
								helperText={errors.password ? errors.password.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="passworRepeat"
								placeholder="Confirmar Contraseña *"
								name="passworRepeat"
								type="password"
								autoComplete="passworRepeat"
								size="small"
								inputRef={register({
									required: "Confirmar contraseña requerida",
									validate: (value) => value === watch("password") || "Las contraseñas no coinciden.",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.passworRepeat ? true : false}
								helperText={errors.passworRepeat ? errors.passworRepeat.message : ""}
							/>
						</Grid>
					</Grid>
					<DialogActions>
						<Button
							type="submit"
							fullWidth
							size="small"
							variant="contained"
							color="secondary"
							className={classes.submit}
							style={{ textTransform: "capitalize", borderRadius: "20px" }}
						>
							Guardar
						</Button>
					</DialogActions>
				</form>
			</DialogContent>
		</Dialog>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
}));
